import { CalendarCloudSettings } from './schema/CalendarCloudSettings';
import { createStore } from 'satcheljs';

const defaultStore: CalendarCloudSettings = {
    shouldEventsEndEarly: null,
    endShortEventsBy: null,
    endLongEventsBy: null,
    enableOnlineMeetingsByDefault: null,
};

export const getCalendarCloudSettingsStore = createStore('CalendarCloudSettings', defaultStore);
